export default __webpack_public_path__ + "static/media/9.06e47f72.jpg";